function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNatureRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3mv0rhoj3a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 117117",
    style: {
      fill: "#d7262e"
    },
    d: "M0 0h42.112v42.043H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137214"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137203"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137202",
    transform: "translate(7.277 6.979)",
    style: {
      clipPath: "url(#3mv0rhoj3a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121131",
    d: "M40.311 24.5a18.6 18.6 0 0 0-17.5 11.7V24.338a10.538 10.538 0 0 0 8.773-10.37c0-7.019-6.829-12.508-6.87-12.546a35.922 35.922 0 0 0-3.658 14.3h-3.509A39.078 39.078 0 0 1 21.509.026a5.3 5.3 0 0 0-4.235 1.5c-3.336 3.4-6.745 7.543-6.745 12.444A10.538 10.538 0 0 0 19.3 24.338V36.2A18.6 18.6 0 0 0 1.8 24.5H0l.223 1.972c1.4 12.32 12.937 15.575 18.833 15.575h4c5.905 0 17.435-3.255 18.83-15.575l.227-1.972z",
    style: {
      fill: "#d7262e"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNatureRed);
export default __webpack_public_path__ + "static/media/icon_nature_red.78d19adbda68cad8b518832d35f632b6.svg";
export { ForwardRef as ReactComponent };